import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "my-[10px]" }

import { ref } from 'vue';
  import axios from 'axios';
  import axiosInstance from '@/plugins/axios';
  
  
export default /*#__PURE__*/_defineComponent({
  __name: 'Responses',
  props: {
    commentId: {},
    username: {}
  },
  setup(__props: any) {

  const props = __props;
  
  const responseContent = ref('');
  
  const submitResponse = async () => {
    try {
      const response = await axiosInstance.post(`/comments/${props.commentId}/responses/`, {
        content: responseContent.value,
        username: "IronSecur",
        comment: props.commentId
      });
      
      responseContent.value = '';
      window.location.reload();
    } catch (error) {
      console.error('Erreur lors de l\'envoi de la réponse :', error);
    }
  };
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("textarea", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((responseContent).value = $event)),
      placeholder: "Votre réponse",
      class: "w-full border outline-none p-[10px] resize-none md:h-[150px] h-[75px] rounded-[5px] focus:border-blue-300"
    }, null, 512), [
      [_vModelText, responseContent.value]
    ]),
    _createElementVNode("button", {
      onClick: submitResponse,
      class: "text-sm font-bold text-white bg-cyan-500 p-[10px]"
    }, "Envoyer")
  ]))
}
}

})